var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSourceTrackingPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "gray",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.383 8.75a7.56 7.56 0 00-6.133-6.133V5c0 .703-.586 1.25-1.25 1.25-.703 0-1.25-.547-1.25-1.25V2.617A7.558 7.558 0 002.578 8.75H5c.664 0 1.25.586 1.25 1.25 0 .703-.586 1.25-1.25 1.25H2.578a7.555 7.555 0 006.172 6.172V15c0-.664.547-1.25 1.25-1.25.664 0 1.25.586 1.25 1.25v2.422a7.558 7.558 0 006.133-6.172H15c-.703 0-1.25-.547-1.25-1.25 0-.664.547-1.25 1.25-1.25h2.383zM0 10C0 4.492 4.453 0 10 0c5.508 0 10 4.492 10 10 0 5.547-4.492 10-10 10A9.97 9.97 0 010 10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceTrackingPlan);
export default __webpack_public_path__ + "static/media/source_tracking_plan.66014689958a555fee385c2614e58493.svg";
export { ForwardRef as ReactComponent };